module.exports = __webpack_public_path__ + "static/cashback-banner-4-7471b6d90c7ca4928c1eb46a305ab297.png";